import React, { Component, Suspense } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import Analytics from 'APP_ROOT/services/analytics';
import errorReporting from 'APP_ROOT/services/errorReporting';

import { updateGlobals } from './globals.js';

import BuildSettings from '../buildSettings';
import { FALLBACK_CHANNEL_BRANDING_URLS } from '../../data/channels';
import Events from './events';
import CognitoUtil from '../aws/cognito/cognitoUtil';
import { tryCookieAuth } from '../aws/cognito/prototypeAuth';
import HistoryUtil from './historyUtil';
import LambdaUtil from '../aws/lambda/lambdaUtil';
import lsUtil from '../common/lsUtil';
import RavenUtil from '../common/ravenUtil';
import { getPageSlugFromPathname } from './routeUtil';
import MqttService, { DEFAULT_PROTOBUF_PROCESS_INTERVAL } from 'APP_ROOT/services/mqtt';
import RavenConfigurationDataSource from 'APP_ROOT/pages/Settings/RavenConfigurationDataSource';
import { strings, getCurrentLocale } from '../../localization';
import { addAllMedia } from '../../data/media/actions';
import { addAllEventsAndLinkMedia, requestImageUrlsForEventIfNeeded } from '../../data/events/actions';
import RavenApiProfile from './apiProfile';
import { determineFeatures } from './views';
import Permissions from '../../data/permissions';
import Protected from '../common/protected';
import hostHandoff from 'APP_ROOT/services/hostHandoff';

import MainNavigation from '../LayoutTemplateModularFullscreen/MainNavigation';
import MainModuleGroup from '../LayoutTemplateModularFullscreen/MainModuleGroup';
import { ACTIVE_MENU_ITEM_IDS, ACTIONS as layoutTemplateModularFullscreenDispatchActions } from '../../data/layoutTemplateModularFullscreen/duck.js';
import UserMenu from '../LayoutTemplateModularFullscreen/UserMenu';
import BuildIdentificationBadge from '../LayoutTemplateModularFullscreen/BuildIdentificationBadge';
import Header from './header/header';
import Footer from './footer';

import History from 'APP_ROOT/pages/History';
import EventSummaryPage from './EventReview/EventSummaryPage';
import Settings from 'APP_ROOT/pages/Settings';
import AccountPage from '../pages/account/accountPage';
import DashboardPage from '../pages/dashboard/dashboardPage';
import LoginPage from '../pages/login/loginPage';
import MediaPage from '../pages/media/mediaPage';
import CreateAccountPage from '../pages/createAccount/createAccountPage';
import VerifyAccountPage from '../pages/createAccount/verifyAccountPage';
import ForgotPasswordPage from '../pages/login/forgotPasswordPage';
import NewPasswordPage from '../pages/login/newPasswordPage';
import ResetPasswordPage from '../pages/login/resetPasswordPage';
import SupportPage from '../pages/support/supportPage';
import TripSharingPage from '../pages/tripSharing/tripSharingPage';
import InvitationPage from '../pages/invitation/invitationPage';
import NotFoundPage from '../pages/notFoundPage';
import LiveStream from '../pages/dashboard/LiveStream/LiveStream'; /* index.js for redux is not available yet */
import LocalizationIssues from '../pages/localizationIssues';
import DeepLink from './deepLink.js';

import ReportsPage from 'APP_ROOT/pages/Reports';
import Coaching from '../../pages/Coaching';
import { addFakeMediaToShowcaseEvents, addFakeEvents } from './showcaseFakes';
import { RESOURCE_GROUP_TYPES } from 'APP_ROOT/components/pages/dashboard/ResourceGroups/constants';
import { fetchRavens, fetchUsers, fetchDashboardAndVehicleStates, fetchCurrentVehicleStates } from 'API_FILE';
import { DispatchHelpers as tags } from '../../data/tags/index.js';
import TagPermissions from './tagsPermissions.js';
import {RcAPI} from "../../components/common/rcApi";
import SelectAccount from '../pages/selectAccount.js';
import FinalizeInvitationPage from '../pages/invitation/finalizeInvitationPage.js';
import BackToTopButton from './BackToTop.js';
import Survey from './Survey.js';
import PermissionsDebugger from '../PermissionsDebugger';
import GridPage from '../pages/grid/GridPage.js';
import { focusSearchInput, requestMapFullscreen } from './keyboardShortcuts';

const PrimePage = React.lazy(() => import('APP_ROOT/pages/Prime'));
const PrimeStorePage = React.lazy(() => import('APP_ROOT/pages/Prime/store/StorePage'));
const CreateAccountFlow = React.lazy(() => import('APP_ROOT/pages/Prime/createAccount/CreateAccountFlow'));

const CHANNEL_STYLE_ID = 'channel-branding-stylesheet';

const compareVehicleNames = (a, b) => {
    let nameA = a.vehicle && a.vehicle.name;
    if (nameA) {
        nameA = nameA.toLowerCase();
    }
    let nameB = b.vehicle && b.vehicle.name;
    if (nameB) {
        nameB = nameB.toLowerCase();
    }
    return nameA > nameB ? 1 : nameA === nameB ? 0 : -1;
};

export class SessionManager extends Component {

    constructor(props) {

        super(props);
        const features = BuildSettings.applyBuildFeatures({
            logo_url: "raven-logo"
        });
        
        this.state = {
            ravens: null,
            users: null,
            ravensSearchFilterOption: null,
            preFilteredRavensVisibilityById: {}, // {resourceId: visible} store which is used to restore resource visibility state when a search filter is cleared
            geofencesSearchFilterOption: null,
            preFilteredGeofencessVisibilityById: {},
            assetsSearchFilterOption: null,
            preFilteredAssetsVisibilityById: {},
            hiddenRavens: null,
            showcaseTargetRavenUuid: null,
            accountDetails: null,
            user: null,
            features: features,
            mapUpdateKey: 0,
            liveStreamSettings: null,
            accounts: null,
            surveys: [],
            currentSurvey: null,
            showCurrentSurvey: false,
            _lastPathname: (props && props.location && props.location.pathname) || null,
            fromSnapshot: false,
        }

        this.dfastEnabled = false;

        window.sessionmanager = this;


    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const nextPath = nextProps && nextProps.location && nextProps.location.pathname;
        const prevPath = prevState && prevState._lastPathname;

        const currentSurvey = (prevState.surveys || []).find(s => nextPath && nextPath.includes(s.path)) || null;

        const stateUpdates = {};

        // If navigation happened, close click surveys immediately
        if (nextPath && nextPath !== prevPath) {
            stateUpdates._lastPathname = nextPath;
            // always close click-mode surveys on nav; popup surveys still render
            stateUpdates.showCurrentSurvey = false;
        }

        // update currentSurvey in state
        stateUpdates.currentSurvey = currentSurvey;

        // return null if nothing changed to avoid extra re-renders
        const keysChanged = Object.keys(stateUpdates).some(k => prevState[k] !== stateUpdates[k]);
        return keysChanged ? stateUpdates : null;
    }

    componentDidMount() {
        document.addEventListener(Events.REFRESH_RAVEN, this.onRefreshRavenEvent);
        document.addEventListener(Events.REFRESH_ALL_RAVENS, this.onRefreshAllRavensEvent);
        
        // Pre-auth branding based on subdomain
        const hostChannelEnv = BuildSettings.getChannelFromHostname();

        if (hostChannelEnv) {
            this.applyChannelBranding(hostChannelEnv.channelCode, hostChannelEnv.channelBrandingBaseUrl);
        }

        this.getPendingInvite();
        window.addEventListener('keydown', this.handleGlobalKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener(Events.REFRESH_RAVEN, this.onRefreshRavenEvent);
        document.removeEventListener(Events.REFRESH_ALL_RAVENS, this.onRefreshAllRavensEvent);
        window.removeEventListener('keydown', this.handleGlobalKeyDown);
    }

    getUserOrRedirectToLogin = () => {
        const redirectToLogin = (msg) => {
            console.log(`SessionManager: ${msg}, redirecting to login`);
            HistoryUtil.push('/');
        }
        const didAttemptCookieAuth = tryCookieAuth('raven.idtoken',
            (userAttributes) => {
                console.log("SessionManager: cookie auth successful, user attributes:", userAttributes);
                const userAttObj = userAttributes.reduce(
                    (acc, attr) => {
                        acc[attr.getName()] = attr.getValue();
                        return acc
                    },
                    {}
                );
                console.log("SessionManager: userAttObj:", userAttObj);
                this.setState({
                    ...this.state,
                    user: {
                        stage: userAttObj['custom:linked_raven_stage'],
                        email: userAttObj['email'],
                    }
                })
            },
            () => {
                // if we don't have a user, redirect to login
                redirectToLogin("error in tryCookieAuth");
            });

        if (!didAttemptCookieAuth) {
            // TODO: we could get user from CognitoUtil.getCurrentUser() too,
            // but for the march networks prototype all I care about is cookie
            // auth --JW
            redirectToLogin("no cookie auth attempt made");
        }
    }

    componentDidUpdate(prevProps) {
        // Check if the route has changed
        const prevPath = prevProps.location && prevProps.location.pathname;
        const currPath = this.props.location && this.props.location.pathname;
        if (prevPath !== currPath && this.state.mqttService) {
            // Route changed, update DFAST interval
            this.state.mqttService.setDfastInterval();
        }
    }

    handleGlobalKeyDown = (e) => {
        // Ignore keydowns on text inputs
        if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) {
            return;
        }

        // Ctrl+F or Cmd+F: open sidebar search
        if ((e.ctrlKey || e.metaKey) && e.key === 'f') {
            
            // only search on snapshot or dashboard page
            const isGridPage = window.location.pathname.includes('/snapshot');
            const isDashboard = window.location.pathname.includes('/dashboard');

            if (isGridPage || isDashboard) {
                e.preventDefault(); // Stop browser search
                focusSearchInput(this.props.setMainModuleGroupNavigation);
            }
            return;
        }

        // F key (no modifier): toggle map fullscreen on dashboard
        if (e.key === 'f' && !e.ctrlKey && !e.metaKey && !e.altKey) {
            const isDashboard = window.location.pathname.includes('/dashboard');
            if (isDashboard) {
                requestMapFullscreen();
            }
        }
    };
    getUserData = (onGetUserDataComplete) => {
        document.dispatchEvent(Events.showLoading({ message: strings.app_loading }));

        // e have session tokens in the hash (fragment), overwrite the current session and reload
        if(hostHandoff.trySignInWithHashSession()) return;

        this.onGetUserDataComplete = onGetUserDataComplete;
        CognitoUtil.refreshLogin(this.onRefreshLoginSuccess, this.onRefreshLoginFail);
    }

    onLogin = (e, email, password, validateEmail, validatePassword) => {

        e.preventDefault();
        var emailValid = validateEmail(email, true);
        var passwordValid = validatePassword(password, true);
        if (emailValid && passwordValid) {
            e.preventDefault();
            CognitoUtil.login(email, password, this.onLoginSuccess, this.onLoginFailed, this.resetPasswordRequired, this.newPasswordRequired);
            document.dispatchEvent(Events.showLoading({ message: strings.sign_in_loading }));
        }
    }

    returnToSupportURL = (returnto) => {
        var linkedRavenStage;
        // attempt to get stage from state's user object (see onRefreshLoginSuccess)
        if (this.state.user !== null) {
            if (this.state.user.stage) {
                linkedRavenStage = this.state.user.stage;
                LambdaUtil.getSupportURL(linkedRavenStage, returnto, this.onSupportURLSuccess, this.onSupportURLFail);
                return;
            }
        }
        // else, attempt to get user stage from attributes via cognito request
        CognitoUtil.cognitoUser.getUserAttributes((error, response) => {
            if (error) {
                console.error(error);
                return;
            }
            if (!response) {
                console.error("Cognito getUserAttributes no response");
                return;
            }
            response.forEach(attribute => {
                const attributeName = attribute.getName();
                const attributeValue = attribute.getValue();
                if (attributeName === "custom:linked_raven_stage") {
                    linkedRavenStage = attributeValue;
                }
            });
            if (linkedRavenStage) {
                LambdaUtil.getSupportURL(linkedRavenStage, returnto, this.onSupportURLSuccess, this.onSupportURLFail);
            } else {
                console.error("Cognito getUserAttributes response missing linked_raven_stage", response);
            }
        });
    }

    onLoginSuccess = (event) => {

        if(!this.state.user) {
            this.setState({
                user: {
                    email: event.email,
                    stage: event.stage,
                }
            });
        }

        // This will set stage for all tags methods
        this.props.dispatch(tags.setStage(event.stage));

        if(this.state.pendingInvite){            
            this.setState({pendingInvite: null});
        }

        if(event.pendingInvite){
            this.setState({
                pendingInvite: 
                    event.pendingInvite
                });

            HistoryUtil.replace('/finalize-invite');
            return;
        }
        
        /* We got here because this callback was registered.  We have a return_to or redirect_to param
            we need to honour.  Redirect there now that we have logged in */
        let returnto = window.location.getParams()['return_to'];
        let redirectTo = window.location.getParams()['redirect_to'];

        if (returnto) {
            Analytics.event({
                category: Analytics.EventCategory.User,
                action: Analytics.EventAction.SignIn,
                label: returnto
            });
            this.returnToSupportURL(returnto);
        } 
        else if (redirectTo) {
            Analytics.event({
                category: Analytics.EventCategory.User,
                action: Analytics.EventAction.SignIn,
                label: redirectTo
            });
            HistoryUtil.replace(redirectTo);
        }
        else {
            Analytics.event({
                category: Analytics.EventCategory.User,
                action: Analytics.EventAction.SignIn,
            });

            const currentUrlParams = new URLSearchParams(window.location.search);
            HistoryUtil.replace(`/select-account?${currentUrlParams.toString()}`);
        }
    }

    isThereAValidPendingInvitation = () => {
        const invite = lsUtil.getItem('raven.invite');
        if(!invite) return false;

        try {
            const inviteObj = JSON.parse(invite);
            if(inviteObj.ignored) return false;
            if(!inviteObj.role || !inviteObj.tag || !inviteObj.token || !inviteObj.signature) return false;
            return true;
        }
        catch(e) {
            return false;
        }
    }

    onSupportURLSuccess = (data) => {

        var payload = JSON.parse(data.Payload);
        if (payload.status === "SUCCESS") {
            /* Redirect to the URL provided */
            window.location.href = payload.ssoUrl;
        }
        else {
            // Failed
            return this.onSupportURLFail(data);
        }
    }

    onSupportURLFail = (data) => {

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        var payload = JSON.parse(data.Payload);
        this.setState({ errorMessage: strings.formatString(strings.sign_in_failed_other) });
        console.error(payload);
    }

    setErrorMessage = errorMessage => {
        this.setState({
            errorMessage
        });
    }

    onLoginFailed = (error) => {
        if(!error) {
            this.setErrorMessage(strings.sign_in_failed_other);
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            return;
        }
        switch (error.code) {
            case "UserNotFoundException":
                this.setErrorMessage(strings.sign_in_failed_bad_username_password_web);
                break;
            case "NotAuthorizedException":
                this.setErrorMessage(strings.sign_in_failed_bad_username_password_web);
                break;
            case "NetworkingError":
                this.setErrorMessage(strings.sign_in_failed_check_internet);
                break;
            default:
                this.setErrorMessage(strings.sign_in_failed_other);
                break;
        }
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    newPasswordRequired = blob => {

        // console.log("new Password Required: ", blob);
        const stage = blob.userAttributes.find(attr => attr.Name === 'custom:linked_raven_stage').Value;
        const email = blob.userAttributes.find(attr => attr.Name === 'email').Value;

        this.setState({
            newPasswordRequired: true,
            op: blob.op,
            user: {
                stage,
                email
            }
        });
        // load the account page.  it has logic to determine if it should open the
        // change password modal or not.
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        HistoryUtil.push('/new-password');
    }

    resetPasswordRequired = e => {

        // console.log(e);
        HistoryUtil.push('/reset-password');
    }

    onRefreshLoginSuccess = (refreshLoginUserAttributesResult) => {

        document.dispatchEvent(Events.showLoading({ message: strings.app_loading }));

        //make user object - used to display email address, etc.
        let user = { email: null };
        let vendor = null; // default vendor is raven
        let userProtobufProcessInterval = DEFAULT_PROTOBUF_PROCESS_INTERVAL;
        for (var i = 0; i < refreshLoginUserAttributesResult.length; i++) {
            const attributeName = refreshLoginUserAttributesResult[i].getName();
            const attributeValue = refreshLoginUserAttributesResult[i].getValue();
            user[attributeName] = attributeValue;
            if (attributeName === "custom:extra_user_flags" && attributeValue.indexOf("vendor_telus") !== -1) {
                vendor = "vendor_telus";
            }
        }
        if (user.hasOwnProperty("custom:mqtt_interval_secs")) {
            if (!isNaN(user["custom:mqtt_interval_secs"])) {
                const userProtobufProcessIntervalSeconds = parseInt(user["custom:mqtt_interval_secs"]);
                if (!isNaN(userProtobufProcessIntervalSeconds)) {
                    userProtobufProcessInterval = userProtobufProcessIntervalSeconds * 1000;
                } else { console.error("Invalid user protobuf process interval (could not parse to a valid value): " + user["custom:mqtt_interval_secs"]); }
            } else { console.error("Invalid user protobuf process interval: " + user["custom:mqtt_interval_secs"]); }
        }
        const currentVendor = lsUtil.getItem('raven.vendor') || null;
        if (vendor !== currentVendor) {
            window.location.reload();
        }
        if (vendor) {
            lsUtil.setItem('raven.vendor', vendor);
        } else {
            lsUtil.removeItem('raven.vendor'); // mostly just useful for debugging purposes
        }

        if (hostHandoff.redirectOnStageHostMismatch(BuildSettings.cloud, user['custom:linked_raven_stage'])) {
            CognitoUtil.logout()
            return;
        }

        // userId cannot contain Personally Identifiable Information (PII) including email
        // address, phone number, etc
        // ref: https://developers.google.com/analytics/solutions/crm-integration#user_id
        Analytics.setUserId(user.sub);
        errorReporting.setUserId(user.sub);

        const userAccountsDetails = CognitoUtil.getUserAccountsDetails();
        const userStage = user['custom:linked_raven_stage'];
        //setting state here causes aws to lose config... not sure why, so holding onto it until setstate occurs after get ravens and account details
        this.setState({
            user: {
                email: user.email,
                preferred_username: user.preferred_username,
                stage: userStage,
                extra_user_flags: user['custom:extra_user_flags'],
                original: user,
                userProtobufProcessInterval: userProtobufProcessInterval,
                franchiseView: user['custom:extra_user_flags'] && user['custom:extra_user_flags'].indexOf("franchise_view") > -1,
                gridViewUiEnabled: user['custom:extra_user_flags'] && user['custom:extra_user_flags'].indexOf("grid_view_ui_enabled") > -1,
                multiAccount: userAccountsDetails ? userAccountsDetails.multiAccount : false,
                currentAccount: userAccountsDetails ? userAccountsDetails.account : null,
            }
        }, () => {
            // This will set stage for all tags methods
            this.props.dispatch(tags.setStage(userStage));
            this.populateUserCurrentAccount(this.finishLogin.bind(this));
        });
    }

    getRavens = () => {
        fetchRavens(this.state.user.stage)
            .then(this.onGetRavensSuccess)
            .catch(this.onGetRavensError);
    }

    getTags = () => {
        this.props.dispatch(tags.loadTags())
            .then((loadedTags) => {
                this.props.setUserResourcePermissions('tags', 'tagId', loadedTags);
            })
            .catch((error) => {
                console.error("Error loading tags:", error);
            });
    }

    getUsers = () => {
        return fetchUsers(this.state.user.stage)
            .then((users) => {
                const uniqueUsers = [];

                users.forEach(user => {
                    if (!uniqueUsers.find(u => u.email === user.email)) {
                        user.tags = TagPermissions.getUserUniqueTags(user);
                        uniqueUsers.push(user);
                    }
                });

                this.setState({users: uniqueUsers});
                return Promise.resolve(uniqueUsers);
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }

    deleteUser = (user) => {
        // A temporary solution to hide a deleted pending user from the list (on next refresh/reload the user won't be included in the cloud response)
        // To Do: Create a reducer (and associated actions and selectors) for handling users loading and manipulating (the same way as tags)
        const users = this.state.users.filter(u => u.email !== user.email);
        this.setState({users: users});
    }

    getSelectedRavenUuid = () => {
        if(this.state.selectedRaven) return this.state.selectedRaven.ravenUuid;
        return lsUtil.getItem('raven.selectedRavenUuid');
    }

    finishLogin() {
        this.loadSurveys();
        
        if (BuildSettings.billingEnabled) {
            document.dispatchEvent(Events.showLoading({ message: strings.app_loading, 'override': true }));
            LambdaUtil.getAccountDetails(this.state.user.stage, Permissions.ACCOUNT_PERMISSIONS_LIST, this.onAccountDetailsSuccess, this.onAccountDetailsFail);
        } else {
            document.dispatchEvent(Events.showLoading({ message: strings.app_loading, 'override': true }));
            this.getRavens();
            this.getTags();
        }
    }

    onRefreshLoginFail = (e) => {

        document.dispatchEvent(Events.showLoading({ message: strings.sign_in_expired }));
        setTimeout(() => {
            CognitoUtil.Timeout();
        }, 5000);
    }

    refreshAccountDetails() {

        LambdaUtil.getAccountDetails(this.state.user.stage, Permissions.ACCOUNT_PERMISSIONS_LIST, this.onAccountDetailsSuccess, this.onAccountDetailsFail);
    }

    onAccountDetailsSuccess = e => {

        try {
            var payload = null;
            if (e.Payload)
                payload = JSON.parse(e.Payload);

            var accountDetails = payload.payload || {};

            // this may be a temporary patch to the this.state.user .
            // I'm using the user object because it's passed down to many components already.
            // It is a convenience property while Prime features are in development in the cloud.
            // userCurrentAccountChannelCode will be applied to this.state.user.channelCode in the next setState below
            const userCurrentAccountChannelCode = accountDetails.channelCode ? accountDetails.channelCode : null;
            const userCurrentAccountChannelBrandingBaseUrl = accountDetails.brandBaseUrl || null;

            this.props.setUserGeneralPermissions(this.state.user.currentAccount, accountDetails);

            this.applyChannelBranding(userCurrentAccountChannelCode, userCurrentAccountChannelBrandingBaseUrl);

            // payload.payload can be undefined for invited users
            if (payload.status && payload.status !== "ERROR" && accountDetails.subscriptions) { //checks if subscriptions exists and is of length > 0 ([] == false)

                // var servicePlanListUrl = '/serviceplans/plans.json';
                // axios({
                //     method: 'get',
                //     url: servicePlanListUrl
                // }).then((response) => {
                //     accountDetails.servicePlans = response.data


                // }).catch(function (response) {
                //     console.error('error', response);
                // });

                //DEBUGGING
                if (BuildSettings.isDev()) {
                    //remove all service plans
                    // accountDetails.subscriptions = [];

                    //duplicate sub with faked dupliated raven as target
                    // accountDetails.subscriptions[1] = JSON.parse(JSON.stringify(accountDetails.subscriptions[0]));
                    // accountDetails.subscriptions[1].raven = { ravenUuid: "222" };

                    //DEBUG For testing when trial is ending.
                    // accountDetails.subscriptions[0].planSelectionRequired = true;
                    // accountDetails.subscriptions[0].planCode = "freetrial";
                    // accountDetails.subscriptions[1].planCode = "freetrial";

                    //DEBUG for testing with no service plan
                    // accountDetails.subscriptions.splice(0, 1);

                    //DEBUG other, force basic plan
                    // accountDetails.subscriptions[0].planCode = "basic";
                    // accountDetails.subscriptions[0].amountInCents = "800";
                    // accountDetails.subscriptions[0].amountInCents = "0";
                    // accountDetails.subscriptions[0].streamingUsedPercent = 50;
                }

                accountDetails.subscriptions.forEach(sub => {

                    if (!sub || !sub.planCode || !sub.subscriptionUuid) return;

                    //add flag for 'no streaming limit' plans for easier reading later
                    if (sub.planCode.indexOf('freetrial') > -1 ||
                        sub.planCode.indexOf('free_trial') > -1 ||
                        sub.planCode.indexOf('journalist') > -1 ||
                        sub.planCode.indexOf('affirm') > -1 ||
                        sub.planCode.indexOf('employee') > -1) {

                        sub.noLimitPlan = true
                    } else {

                        sub.noLimitPlan = false
                    }
                    //flag plans that will be replaced with pending plan at end of cycle
                    accountDetails.subscriptions.forEach(sub2 => {
                        if (sub2.state === 'pending' && sub.subsciptionUuid === sub2.subsciptionUuid) sub.pendingSub = sub2; //make pendingSub ref
                    })
                })

                errorReporting.setAccountType(accountDetails.accountType);

                // Older kloud may not provide channel id
                if (accountDetails.channelId) {
                    errorReporting.setChannelId(accountDetails.channelId);
                }
                if (accountDetails.channelCode) {
                    errorReporting.setChannelCode(accountDetails.channelCode);
                }

                this.setState({
                    user: {
                        ...this.state.user,
                        accountChannelCode: userCurrentAccountChannelCode
                    },
                    accountDetails: accountDetails,
                }, () => {
                    //also get service plans
                    LambdaUtil.listServicePlans(this.state.user.stage, this.onListServicePlansSuccess, this.onListServicePlansFail);
                });
            } else {
                //no recurly account. Still get list of ravens, this is
                // an old code path that is now being used again for
                // non-legacy channels
                if (accountDetails.hasOwnProperty("accountType")) {
                    errorReporting.setAccountType(accountDetails.accountType);
                }
                if (accountDetails.hasOwnProperty("channelId")) {
                    errorReporting.setChannelId(accountDetails.channelId);
                }
                if (accountDetails.hasOwnProperty("channelCode")) {
                    errorReporting.setChannelCode(accountDetails.channelCode);
                }

                this.setEmailForChannelAccount(accountDetails);

                // Fixes RAV-2010 (onGetRavensSuccess crashes at accountDetails.subscriptions.find())
                accountDetails.subscriptions = [];

                this.setState({
                    user: {
                        ...this.state.user,
                        accountChannelCode: userCurrentAccountChannelCode
                    },
                    accountDetails: accountDetails,
                }, () => {
                    this.getRavens();
                    this.getTags();
                });
            }
        } catch (e) {
            this.onAccountDetailsFail(e);
        }
    }

    setEmailForChannelAccount = (accountDetails) => {
        if(!accountDetails.email){
            const userCurrentAccount = this.state.user.currentAccount;

            if(userCurrentAccount){
                accountDetails.email = userCurrentAccount.email;
                return;
            }
            
            console.error("No current account found for user");
            CognitoUtil.logout();
            window.location.href = '/?error=error_loading_accounts';
        }
    }

    onAccountDetailsFail = e => {
        console.error(e);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        CognitoUtil.logout();
        window.location.href = "/?error=sign_in_account_details_error";
    }

    onListServicePlansSuccess = (response) => {

        var servicePlans = null
        try {
            if (response.Payload)
                servicePlans = JSON.parse(response.Payload).listServicePlans;

            this.setState({
                availableServicePlans: servicePlans.plans
            })
            this.getRavens();
            this.getTags();
        } catch (e) {
            this.onListServicePlansFail(e);
        }
    }

    onListServicePlansFail = (error) => {

        console.error(error);

        errorReporting.error(error);
    }

    populateUserCurrentAccount = (callback) => {
        const {accounts, user} = this.state;

        // during refreshLogin, this state value is set with data from localstorage
        // Calling it currentAccountRef because it just includes the accountId
        const currentAccountRef = user.currentAccount;
        
        // User has no selected account saved in localstorage, so redirect to /select-account
        if(!currentAccountRef) {
            HistoryUtil.push('/select-account');
            return;
        }

        const setCurrentAccount = (accounts) => {
            
            if(accounts && accounts.length > 0) {
                const currentAccount = accounts.find(acc => acc.accountId === currentAccountRef.accountId);
                if(currentAccount) {
                    this.setState({
                        user: {
                            ...user,
                            currentAccount: currentAccount,
                            multiAccount: accounts.length > 1
                        }
                    }, () => {
                        if(callback) callback();
                    });
                } else {
                    resetCurrentAccount('Current account not found in user accounts list');
                }
            }
            else {
                resetCurrentAccount('User accounts list is empty or null');
            }
        }

        const resetCurrentAccount = (error) => {
            this.setState({
                user: {
                    ...user,
                    currentAccount: null,
                    multiAccount: false
                }
            }, () => {
                CognitoUtil.clearUserAccountsDetails();
                console.error("Error populating user account, redirecting to select account page", error);
                HistoryUtil.push('/select-account');
            });
        }

        if(accounts) {
            setCurrentAccount(accounts);
        }
        else {
            this.getUserAccounts(setCurrentAccount);
        }
    }

    getUserAccounts = (onSuccess) => {
        document.dispatchEvent(Events.showLoading({ message: strings.app_loading }));
        
        LambdaUtil.getAccounts( this.state.user.stage, (result) => {
            try{
                const payload = JSON.parse(result.Payload);

                const accounts = payload.accounts.accounts;
                
                this.setState({accounts: accounts});

                onSuccess(accounts);
            }
            catch(error){
                this.onGetUserAccountsFail(error);
            }
            
        }, this.onGetUserAccountsFail);
    }

    onGetUserAccountsFail = (error) => {
        console.error(error);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        CognitoUtil.logout();
        window.location.href = '/?error=error_loading_accounts';
    }

    onAccountSelected = (account, path) => {
        // If user only has one account or if user has multiple accounts and is selecting an account for the first time (after login),
        // no need to
        // - Reset state (ravens, users, ...)
        // - Call RcAPI.refreshTempCredentials
        // - Reset tags (when multiple accounts)
        // Just set the account and redirect the user
        if ((this.state.accounts.length  === 1) || (!this.state.user.currentAccount)) {            
            this.setAccount(account);
            this.redirectUser(path);
            return;
        }

        // User switching accounts, r
        // so need to
        // - Reset state (ravens, users, ...)
        // - Reset tags
        // - Reset user's permissions
        // - Call RcAPI.refreshTempCredentials for the new account

        const user = this.state.user;

        const features = BuildSettings.applyBuildFeatures({
            logo_url: "raven-logo"
        });

        this.setState({
            ravens: null,
            users: null,
            features,
            ravensSearchFilterOption: null,
            preFilteredRavensVisibilityById: {},
            geofencesSearchFilterOption: null,
            preFilteredGeofencessVisibilityById: {},
            assetsSearchFilterOption: null,
            preFilteredAssetsVisibilityById: {},
            accountDetails: null,
            user: user
        });

        this.props.clearUserPermissions();
        
        this.props.dispatch(tags.resetTags());

        this.setAccount(account);

        // get new session based on new account.
        RcAPI.refreshTempCredentials(this.state.user.stage)
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            this.redirectUser();
        });

    }

    setAccount = (account) => {
        const isMultiAccount = this.state.accounts.length > 1;

        CognitoUtil.setUserAccountsDetails(account, isMultiAccount);

        this.setState({
            user: {
                ...this.state.user,
                currentAccount: account,
                multiAccount: isMultiAccount
            }
        });
    }

    redirectUser = (path) => {
        this.targetPage = '/dashboard';
        if (path) {
            this.targetPage = path;
            lsUtil.removeItem('raven.redirect_after_login');
        }

        // If user is logging in (And not switching accounts),
        if(!this.state.user.currentAccount){
            // If there is invitations or app_user_mgmt in the url, redirect to profile page
            if (this.isThereAValidPendingInvitation() || window.location.search.indexOf("app_user_mgmt") > -1) {
                this.targetPage = '/account/profile';
            }
        }

        HistoryUtil.push(this.targetPage);
    }

    goToSelectAccountPage = () => {
        HistoryUtil.push('/select-account');
    }

    cancelSelectAccount = (e) => {
        e.preventDefault();
        HistoryUtil.pop();
    }

    /**
     * return the ravenUuid to send ctrl messages to in showcase stage
     *
     * undefined for non-showcase stages
     **/
    getShowcaseTargetRavenUuidIfRequired(features, hiddenRavens) {
        if(features.showcase_raven_selector && hiddenRavens && hiddenRavens.length) {
            if(hiddenRavens.length === 1) {
                return hiddenRavens[0].ravenUuid;
            } else {
                const storedShowcaseTarget = lsUtil.getItem('showcase-targetRavenUuid');
                if (storedShowcaseTarget
                    && hiddenRavens.some(r => r.ravenUuid === storedShowcaseTarget)) {
                    return storedShowcaseTarget;
                } else {
                    return hiddenRavens[0].ravenUuid;
                }
            }
        }
    }

    onShowcaseRavenChanged = ravenUuid => {
        this.setState({showcaseTargetRavenUuid: ravenUuid});
        lsUtil.setItem('showcase-targetRavenUuid', ravenUuid);
    }

    extractUniqueRavens = (fetchedRavens) => {
        const ravens = [];

        fetchedRavens.forEach(fetchedRaven => {
            const raven = ravens.find(r => r.ravenUuid === fetchedRaven.ravenUuid);

            if(!raven) {
                ravens.push(fetchedRaven);
            }
            else{
                if(raven.accessLevel === 'GUEST' && (fetchedRaven.accessLevel === 'OWNER' || fetchedRaven.accessLevel === 'ADMIN')){
                    raven.accessLevel = fetchedRaven.accessLevel;
                }
            }
        });

        return ravens;
    }

    onGetRavensSuccess = fetchedRavens => {        
        let ravens = this.extractUniqueRavens(fetchedRavens);

        const features = determineFeatures(this.state.features, this.state.accountDetails, ravens, this.state.user['extra_user_flags']);

        this.props.setUserResourcePermissions('ravens', 'ravenUuid', ravens);

        ravens = this.decorateRavensWithPermissions(ravens);

        if (!ravens || (ravens && ravens.length === 0) ) {
            //this is the case we know the user doesn't exist in the database, so go make a user

            this.createKloudUser();
            //no ravens on account, still allow login to access account
            this.setState({
                ravens: [],
                selectedRaven: null,
                features,
            }, () => {
                // Use the set state callback to ensure the state is set prior to initializing mqtt
                // Connect to MQTT service once we know which Ravens we are to connect to
                if (this.onGetUserDataComplete) {
                    this.onGetUserDataCompleteCalled = true;
                    this.onGetUserDataComplete();
                }
            });
            return;
        }

        //straight away we don't want to deal with ravens that are only an invitation, they should NEVER be shown. Only AFTER the invitation is accepted should they be shown.
        ravens = ravens.filter(raven => {
            return raven.accessLevel !== "INVITATION"
        })
        // showcase account can have Ravens provisioned that should not be shown on the map. These get HIDDEN status.
        const hiddenRavens = ravens.filter(raven => raven.status === 'HIDDEN');
        ravens = ravens.filter(raven => raven.status !== 'HIDDEN');

        // Pull out any overdue Ravens
        const overdueRavens = ravens.filter(raven => raven.status === 'OVERDUE');
        ravens = ravens.filter(raven => raven.status !== 'OVERDUE');

        // sort ravens alphabetically, by vehicle name
        ravens = ravens.sort(compareVehicleNames);

        //check if user is owner, if so we need to check if they're paying.
        //otherwise a user can proceed to view ravens shared with them.
        var selectedRaven = null;
        if (ravens.length === 1 || lsUtil.getItem('raven.selectedRavenUuid')) selectedRaven = RavenUtil.getSelectedRaven(ravens);

        // for (var i = 0; i < 15; i++) {
        //     ravens.push(JSON.parse(JSON.stringify(ravens[0])))
        // }
        // DEBUG create fake duplicate raven
        // ravens[1] = JSON.parse(JSON.stringify(ravens[0]));
        // ravens[1].ravenUuid = "222"
        // ravens[1] = ravens[0];

        //mark ravens with "no service plan" by moving them to another array - makes it not render on dashboard, other pages
        if (this.state.accountDetails) {
            ravens.forEach(raven => {
                raven.queryCompleteTime = Date.now(); //used to identify when the last query was done at, so in the future we can compare them.
                if(!raven.vehicleState)
                    raven.vehicleState = {}
                // if (raven.accessLevel === "OWNER") { // RAV-5966: Do the check for all users, not just OWNER
                    var sub = this.state.accountDetails.subscriptions.find(sub => {
                        return raven.ravenUuid === sub.raven.ravenUuid;
                    });

                    if (sub && sub.planCode === 'nsp') {
                        raven.noServicePlan = true; //flag used when looping through all ravens
                    }
            })
        }

        // Loop through all Ravens once, updating for a few things, instead of n times, 1 per thing
        ravens.forEach(raven => {
            // normalize lastLocation.ts
            if (raven.lastLocation && raven.lastLocation.ts) {
                raven.lastLocation.ts = RavenUtil.toDate(raven.lastLocation.ts)
            }
            // attach Raven Api Profiles
            raven.apiProfile = RavenApiProfile(raven.ravenApiLevel);
            // apply resource group type
            raven.type = RESOURCE_GROUP_TYPES.RAVEN;
        });

        // console.log("Ravens: ", ravens, "\nSelectedRaven: ", selectedRaven);
        this.setState({
            ravens: ravens,
            hiddenRavens: hiddenRavens,
            overdueRavens: overdueRavens,
            showcaseTargetRavenUuid: this.getShowcaseTargetRavenUuidIfRequired(this.state.features, hiddenRavens),
            selectedRaven: selectedRaven,
            features,
        }, () => {
            // Use the set state callback to ensure the state is set prior to initializing mqtt
            // Connect to MQTT service once we know which Ravens we are to connect to

            const userProtobufProcessInterval = this.state.user ? this.state.user.userProtobufProcessInterval : undefined;

            if (!this.state.mqttService) {

                const initializeMqtt = async () => { // In order to use the while+await+interval race condition patch below, I need a wrapper async function

                    let userIdentityId = CognitoUtil.getIdentityId(); // I keep seeing "TypeError: Cannot read properties of undefined (reading 'split') [in MqttService constructor for `var pieces = userid.split(':');`]"

                    // check for crashy race condition state where userIdenityId is undefined
                    // this is the only spot the mqttService is brought up, so we need to wait or fix the race condition somewhere else and risk regressions
                    while (!userIdentityId) { // after reviewing how CognitoUtil stores the identity id and returns it, I felt the best way to avoid this race condition (due to time constraints) is a simple async loop until CognitoUtil has an identityId stored
                        userIdentityId = await Promise.all([ // stop until userIdentity is available
                            // Step 1 - warn in the console
                            () => {console.log("sessionManager onGetRavenSuccess user identity id is undefined. Retrying ...")}, // CRINGE: this will spit out in the console 10 times a second
                            // Step 2 - check to see if local store has the userIdentityId yet
                            userIdentityId = CognitoUtil.getIdentityId(),
                            // Step 3 - repeat after a short delay
                            () => { if (!userIdentityId) { new Promise( (resolve) => setTimeout(resolve, 100) ); } } // retry 10 times a second (trying to avoid too much of a delay, but this avoids a crash so ...)
                        ]);
                    }

                    const mqttService = new MqttService(this, userIdentityId, this.props.dispatch, this.dfastEnabled, userProtobufProcessInterval);
                    const ravenConfigDataSource = new RavenConfigurationDataSource(mqttService);
                    this.setState({
                        mqttService,
                        ravenConfigDataSource,
                    });
                }
                initializeMqtt();

            } else if (userProtobufProcessInterval) {
                this.state.mqttService.applyProtobufProcessInterval(userProtobufProcessInterval);
            }
            if (this.onGetUserDataComplete) {
                this.onGetUserDataCompleteCalled = true;
                this.onGetUserDataComplete();
            }
        });
    }

    updateSessionStateForRaven = (raven) => { // a cleaned up and simplified replacement for reconcileRavenObject()

        this.updateSessionStateForRavenCore(raven);

        this.setState({ ravens: this.state.ravens, mapUpdateKey: Date.now() });
    }

    updateSessionStateForRavenCore = (raven) => { // a cleaned up and simplified replacement for reconcileRavenObject()

        const ravenUuid = raven.ravenUuid;

        var ravenFoundInState = this.state.ravens.find(raven => { return raven.ravenUuid === ravenUuid });

        if (!ravenFoundInState) {
            console.error("updateSessionStateForRaven error, raven for uuid not found in state");
            return; // raven removed before async query callback executed!?
        }

        if (!raven.vehicleState) {
            raven.vehicleState = {};
        }
        if (!raven.dashboard) {
            raven.dashboard = { route: [], events: [], allSupportedEvents: [], type: 'unknown' }; //TODO remove by moving to the redux store (this comment is regarding allSupportedEvents, specifically)
        }

        ravenFoundInState.dashboard.events = raven.dashboard.events.filter(event => document.filterEvent(event)); // remove unsupported events (see allowedEvents in polyfills.js)

        ravenFoundInState.isDriving = RavenUtil.isDriving(raven);
        ravenFoundInState.isIdling = RavenUtil.isIdling(raven.dashboard) ? true : false;

    }

    onGetRavensError = (error) => {

        console.error(error);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        CognitoUtil.logout();
        window.location.href = "/?error=sign_in_get_ravens_error";
    }

    //when cognito user is logged in but doesn't have account details, create Kloud User since they won't exist at this point
    createKloudUser = (e) => {

        // console.log(e);
        LambdaUtil.createKloudUser(this.state.user.stage, this.state.user.email, this.state.user.preferred_username, this.createKloudUserSuccess, this.createKloudUserFail);
    }

    createKloudUserFail = (error) => {

        console.error(error);
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.setState({
            errorMessage: strings.formatString(strings.error_create_kloud_user)
        });
    }

    createKloudUserSuccess = (e) => {

        // console.log(e);
        var payload = JSON.parse(e.Payload);
        if (payload && payload.status && payload.status === "ERROR") {
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            console.error(e);
            this.setState({
                errorMessage: strings.formatString(strings.error_create_kloud_user)
            });
        } else {
            // console.log("successfully created kloud user & account", e);
            //NOTE at this point, we haven't and don't need to re-query for ravens on account since the acocunt page will do the request
            HistoryUtil.push('/account/profile'); //go to page after done creating user
        }
    }

    onLogout = (e) => {

        e.preventDefault();
        CognitoUtil.logout();
        lsUtil.removeItem('raven.redirect_after_login');
        this.setState({
            user: null,
            ravens: null,
            users: null,
            ravensSearchFilterOption: null,
            preFilteredRavensVisibilityById: {},
            geofencesSearchFilterOption: null,
            preFilteredGeofencessVisibilityById: {},
            assetsSearchFilterOption: null,
            preFilteredAssetsVisibilityById: {},
            accountDetails: null,
            currentSurvey: null,
            surveys: [],
            showCurrentSurvey: false,
        }, () => {
            document.dispatchEvent(Events.showLoading({ message: strings.app_loading }));
            window.location.href = '/' + getCurrentLocale();
            // HistoryUtil.push('/');
        });
        Analytics.event({
            category: Analytics.EventCategory.User,
            action: Analytics.EventAction.SignOut,
        });
    }

    _setVisible = (type, visible, ravenUuids) => {

        if(!this.state.ravens) return;
        this.setState(function(state) {
            return {
                ravens: state.ravens.map(function(raven) {
                    if(!ravenUuids || ravenUuids.includes(raven.ravenUuid)){
                        if(!raven.hidden === visible) {
                            // console.log(`${raven.ravenUuid} unchanged`);
                            return raven;
                        }
                        // return a copy of the raven with a new hidden value
                        // console.log(`${raven.ravenUuid} CHANGED`);
                        return {
                            ...raven,
                            hidden: !visible
                        };
                    }
                    // console.log(`${raven.ravenUuid} didn't match`);
                    return raven;
                }),
                mapUpdateKey: Date.now(),
            };
        });
    }

    setVisible = (ravenUuid, visible) => {
        this._setVisible("FIXME", visible, [ravenUuid]);
    };

    setAllVisible = (type, visible) => {
        this._setVisible(type, visible);
    };

    setRavensSearchFilterOption = (ravensSearchFilterOption, preFilteredRavensVisibilityById) => {
        this.setState({
            ravensSearchFilterOption,
            preFilteredRavensVisibilityById: preFilteredRavensVisibilityById ? preFilteredRavensVisibilityById : this.state.preFilteredRavensVisibilityById
        });
    }

    setGeofencesSearchFilterOption = (geofencesSearchFilterOption, preFilteredGeofencessVisibilityById) => {
        this.setState({
            geofencesSearchFilterOption,
            preFilteredGeofencessVisibilityById: preFilteredGeofencessVisibilityById ? preFilteredGeofencessVisibilityById : this.state.preFilteredGeofencessVisibilityById
        });
    }

    setAssetsSearchFilterOption = (assetsSearchFilterOption, preFilteredAssetsVisibilityById) => {
        this.setState({
            assetsSearchFilterOption,
            preFilteredAssetsVisibilityById: preFilteredAssetsVisibilityById ? preFilteredAssetsVisibilityById : this.state.preFilteredAssetsVisibilityById
        });
    }    

    changeVehicleName = (raven, newName) => {
        raven.vehicle._pendingName = newName;
        this.updateRavens();
        LambdaUtil.setVehicleName(this.state.user.stage, raven.ravenUuid, newName)
            .then(() => {
                const { _pendingName, ...vehicle } = raven.vehicle;
                vehicle.name = newName;
                raven.vehicle = vehicle;
                this.updateRavens();
            }).catch(err => {
                const { _pendingName, ...vehicle } = raven.vehicle;
                raven.vehicle = vehicle;
                console.warn('Error setting vehicle name');
                delete raven.vehicle._pendingName;
                errorReporting.error(err);
                this.updateRavens();
            });
    };

    /* Call from MQTT service to reset the Raven state with latest MQTT data */
    //also adds flag for raven being live. This is used to visually show when the raven has been updated.
    updateRavens = (ravens = this.state.ravens) => {

            // Update selected Raven along with all the other Ravens
        var targetRaven = RavenUtil.getSelectedRaven(ravens);
        this.setState({
            ravens: ravens,
            selectedRaven: targetRaven,
            mapUpdateKey: Date.now(),
        })
    }

    onSelectRaven = (ravenUuid) => {

        if (!this.state.selectedRaven || this.state.selectedRaven.ravenUuid !== ravenUuid) {
            lsUtil.setItem('raven.selectedRavenUuid', ravenUuid);
            var targetRaven = RavenUtil.getSelectedRaven(this.state.ravens);
            this.setState({
                selectedRaven: targetRaven,
                selectedEvent: null
            }, () => {
                this.queueRavenSwitchQueries(); //send a dfast if staying on this raven for more than x seconds
            })
        }
        else
        {
            // Requst dashboard info
            this.queueRavenSwitchQueries(); 
        }
    }

    //attempt an all ravens dfast after a cooldown - in case user is flipping between ravens quickly, no need to send a dfast every click.
    //only if paused on a raven for a short while
    // Also grab the dashboard info (blue line, trail, whatever you want to call it)
    queueRavenSwitchQueries() {
        if (this.sendDfastTimeout) clearTimeout(this.sendDfastTimeout);
        this.sendDfastTimeout = setTimeout(() => {
            if(this.state.selectedRaven) this.getRavenDashboard(this.state.selectedRaven);
            this.updateRavensLive();
        }, 1500);
    }

    //send a dfast to all ravens and verify integrity of data with a database query of historical data
    //reset dfast interval & timer
    updateRavensLive() {
        try {
            if (this.state.mqttService) {
                this.state.mqttService.sendAllRavensDfast();
            } else {
                console.warn('Cannot start dfast because mqttService is null');
            }
        } catch (e) {
            console.error(e);
        }
    }

    onSelectEvent = (event) => {

        document.dispatchEvent(new CustomEvent(Events.SELECT_EVENT, { detail: { event: event } }));

        if(event) {
            this.props.dispatch(requestImageUrlsForEventIfNeeded(this.state.selectedRaven.ravenUuid, event.eventId));
        }

        this.setState({
            selectedEvent: event
        });
    }

    loadDashboard = () => {

        try {
            // Only grab the current Vehicle states, not all Vehicle info for most Ravens
            // Grab all the info for the currently selected Raven
            var selectedUuid = this.getSelectedRavenUuid();
            const success = this.getCurrentVehicleStates(selectedUuid);
            if (!success) {
                document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE)); // RAV-3607
            }
        } catch (e) {
            console.error(e);
        }
    }

    queryRavenDashboard(ravenUuid) {
        var raven = this.state.ravens.find(raven => { return raven.ravenUuid === ravenUuid });
        if(raven)
        {
            this.getRavenDashboard(raven);
        }
    }

    // Get the current Vehicle states for all Ravens and all info for the selected Raven, if any
    getCurrentVehicleStates = (selectedUuid) => {

        var uuids = this.state.ravens.map( (raven) => raven.ravenUuid );

        if(uuids.length <= 0)
        {
            return false;
        }

        fetchCurrentVehicleStates(this.state.user.stage, uuids, selectedUuid)
            .then(query => {
                this.getCurrentVehicleStateSuccess(this.state.ravens, selectedUuid, query);
            })
            .catch(err => {
                console.error(err);
                CognitoUtil.Timeout();
            });

        return true;
    }

    getRavenDashboard(raven) {
        if (raven.noServicePlan) return;

        fetchDashboardAndVehicleStates(this.state.user.stage, [raven.ravenUuid])
            .then(query => this.getRavenDashboardSuccess([raven], query))
            .catch(err => {
                console.error(err);
                CognitoUtil.Timeout();
            });

        return true;
    }

    dispatchDashboardToStore = (ravenUuid, dashboard) => {
        if (!dashboard) return;
        if (this.state.features.showcase_sample_videos) {
            dashboard = addFakeMediaToShowcaseEvents(ravenUuid, dashboard);
        }
        if (dashboard.media) {
            this.props.dispatch(
                addAllMedia(ravenUuid,
                    dashboard.media.map(({ ts, url, statusTime, ...it }) => ({
                        ...it,
                        key: url,
                        timestamp: RavenUtil.toDate(ts),
                        statusTime: RavenUtil.toDate(statusTime),
                    }))
                )
            );
        }
        if (dashboard.eventList) {
            this.props.dispatch(
                addAllEventsAndLinkMedia(ravenUuid,
                    dashboard.eventList.map(({ts, mediaList, ...it}) => ({
                        ...it,
                        mediaIds: mediaList.filter(m => m && m.mediaId).map(m => m.mediaId),
                        timestamp: RavenUtil.toDate(ts)
                    }))
                )
            );
        }
    }

    getCurrentVehicleStateSuccess = (ravens, selectedRavenUuid, results) => {

        for(var i = 0; i < ravens.length; i++)
        {
            var raven = ravens[i];
            var ravenUuid = raven.ravenUuid;

            // Handle the selected Raven special as it has full info in the response
            if(ravenUuid === selectedRavenUuid)
            {
                this.getRavenDashboardSuccess([raven], results);
            }

            if (results['vehicle_'+ravenUuid])
            {
                var vehicleState = results['vehicle_'+ravenUuid];

                if (!raven.vehicleState) raven.vehicleState = {};
                //heading
                raven = RavenUtil.updateHeading(raven);

                //update vehicle state
                this.onVehicleStateSuccess(raven, vehicleState);

                /* Reconcile with the older stuff - updates the state */
                this.updateSessionStateForRavenCore(raven);


            }
        }

        if(this.state.selectedRaven) {
            this.calculateRouteDistance(this.state.selectedRaven);

            if (this.state.selectedEvent) {
                this.props.dispatch(requestImageUrlsForEventIfNeeded(this.state.selectedRaven.ravenUuid, this.state.selectedEvent.eventId));
            }
        }

        // Only call setState once instead of once per Raven
        this.setState({ ravens: this.state.ravens, mapUpdateKey: Date.now() });

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

    }

    getRavenDashboardSuccess = (ravens, results) => {

        for(var i = 0; i < ravens.length; i++)
        {
            var raven = ravens[i];
            var ravenUuid = raven.ravenUuid;

            if (results['raven_'+ravenUuid] && results['vehicle_'+ravenUuid])
            {
                var dashboard = results['raven_'+ravenUuid];
                var vehicleState = results['vehicle_'+ravenUuid];

                //ravens and selectedraven need to be updated in the state. The below *does* in fact update the selectedraven and the raven in the ravens array.
                raven.dashboard = dashboard;

                // Create some fake events on the dashboard for showcase
                if (this.state.features.showcase_fake_events) {
                    addFakeEvents(raven.dashboard);
                }
                // take our redux copies before they get mangled
                this.dispatchDashboardToStore(raven.ravenUuid, raven.dashboard);

                if(!raven.dashboard) raven.dashboard = {};

                raven.dashboard.route = raven.dashboard.route ? RavenUtil.sortRoute(raven.dashboard.route) : [];
                raven.dashboard.allSupportedEvents = raven.dashboard.events ? JSON.parse(JSON.stringify(raven.dashboard.events)) : []; //TODO remove by moving to the redux store (JSON is being used as a deep copy solution)
                raven.dashboard.events = raven.dashboard.events ? RavenUtil.sortEvents(raven.dashboard.events) : [];

                if (!raven.vehicleState) raven.vehicleState = {};
                //heading
                raven = RavenUtil.updateHeading(raven);
                raven.dashboard.queryCompleteTime = Date.now(); //used to identify when the last query was done at, so in the future we can compare them.

                //update vehicle state
                this.onVehicleStateSuccess(raven, vehicleState);

                this.calculateRouteDistance(this.state.selectedRaven);

                /* Reconcile with the older stuff - updates the state */
                this.updateSessionStateForRaven(raven);

                document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

                if (this.state.selectedEvent) {
                    this.props.dispatch(requestImageUrlsForEventIfNeeded(this.state.selectedRaven.ravenUuid, this.state.selectedEvent.eventId));
                }

            }
        }
    }


    onVehicleStateSuccess = (raven, vehicleState) => {

        vehicleState.heading = vehicleState.currentCompassHeading;
        raven.vehicleState = vehicleState;
        //do next step - get preview image urls (to be shown in "live feed" until live images come in over MQTT)
        if(raven.vehicleState.currentPreviewUrls)
        {
            raven.vehicleState.currentPreviewUrls.forEach((targetPreviewUrl, index) => {
                if (targetPreviewUrl && targetPreviewUrl.url) {
                    var bucketName = targetPreviewUrl.url.slice(0, targetPreviewUrl.url.indexOf('/'));
                    var keyName = targetPreviewUrl.url.slice(targetPreviewUrl.url.indexOf('/') + 1);
                    lsUtil.setItem(lsUtil.S3.BUCKET_NAME, bucketName);
                    lsUtil.setItem(lsUtil.S3.USER_DATA_PATH_KEY, targetPreviewUrl.url.slice(targetPreviewUrl.url.indexOf('/') + 1, targetPreviewUrl.url.lastIndexOf('/') + 1));
                    new window.AWS.S3().getSignedUrl('getObject', { Bucket: bucketName, Key: keyName }, (err, url) => this.onDashboardImageSuccess(raven, err, url, index));
                }
            });
        }
    }

    calculateRouteDistance(raven) {

        if (raven.dashboard && raven.dashboard.route) {
            raven.tripDistance = RavenUtil.routeDistanceInKm(raven.dashboard.route);
        }
        if (this.distanceTimeout) clearTimeout(this.distanceTimeout);
        this.distanceTimeout = setTimeout(() => { //refresh this every xx sections
            this.calculateRouteDistance(raven)
        }, 15000);
    }

    onVehicleStateError = (err, data) => {

        console.log(err, data);
    }

    onDashboardImageSuccess = (raven, err, url, index) => {

        if (err) {
            console.error(err);
            return;
        }
        if(raven.vehicleState.currentPreviewUrls)
        {
            if(raven.vehicleState.currentPreviewUrls[index])
            {
                raven.vehicleState.currentPreviewUrls[index].finalUrl = url;
                this.setState({
                    ravens: this.state.ravens
                });
            }
        }
    }

    updatesDelayed(isDelayed) {

        // This apparently isn't used, and is causing undue rerenders
        // this.setState({ updatesDelayed: isDelayed })
    }

    enableDFast = (isEnabled) => {
        // Disable dfast when not required (when dashboard not in view)
        this.dfastEnabled = isEnabled;
        if (this.state.mqttService) this.state.mqttService.enableDfast(isEnabled);
    }

    onRefreshRavenEvent = (e) => {
        var selectedUuid = this.getSelectedRavenUuid();
        if(e && e.detail && e.detail.ravenUuid)
        {
            // Only query the dashboard for the currently selected Raven
            if(selectedUuid === e.detail.ravenUuid)
            {
                this.queryRavenDashboard(e.detail.ravenUuid);
            }
        }
        else
        {
            // query the vehicle state for all vehicles and the dashboard for the currently selected Raven
            this.getCurrentVehicleStates(selectedUuid);
        }
    }

    onRefreshAllRavensEvent = () => {
        const { stage } = this.state.user || {};
        if(stage) {
            fetchRavens(stage).then(fetchedRavens => {
                let ravens = this.extractUniqueRavens(fetchedRavens);
                ravens = this.decorateRavensWithPermissions(ravens);
                
                this.setState(state => {
                    if (!state.ravens) return {};
                    return {
                        ravens: ravens.filter(it => it.status === 'PROVISIONED' || it.status === 'SUSPENDED')
                        .sort(compareVehicleNames)
                        .map(it => {
                            const raven = state.ravens.find(r => r.ravenUuid === it.ravenUuid);
                            if (raven) {
                                // if the raven is in the list, update its vehicle (for Driver Detected event)
                                raven.vehicle = {
                                    ...raven.vehicle,
                                    currentDriver: it.vehicle.currentDriver,
                                    activeDTCs: [...it.vehicle.activeDTCs]
                                };

                                // Update it's last known location if we have the info
                                if(it.lastLocation && it.lastLocation.ts)
                                {
                                    raven.lastLocation = { ... it.lastLocation };
                                    raven.lastLocation.ts = RavenUtil.toDate(raven.lastLocation.ts)
                                }
                                return raven;
                            }
                            // else it's new-found raven
                            it.apiProfile = RavenApiProfile(it.ravenApiLevel);
                            it.type = RESOURCE_GROUP_TYPES.RAVEN;
                            return it;
                        })
                    };
                });
            }).catch(error => {
                console.error(error);
            });
        }
    }

    pokeMap = () => {
        this.setState({
            mapUpdateKey: Date.now()
        });
    }

    onCloseLiveStream = () => {
        this.setState({liveStreamSettings: null});
    }

    onLiveStream = (liveStreamObj) => {

        this.setState({liveStreamSettings: liveStreamObj});
    }

    decorateRavensWithPermissions = (ravens) => {
        if (!ravens || ravens.length === 0) {
            return ravens;
        }

        return ravens.map(raven => ({
            ...raven,
            canEdit: this.props.checkPermission('ravens.self', 'write', { resourceId: raven.ravenUuid }),
            canViewMedia: this.props.checkPermission('ravens.media', 'read', { resourceId: raven.ravenUuid }),
            canRequestMedia: this.props.checkPermission('ravens.media', 'request', { resourceId: raven.ravenUuid }),
            canViewVideoStream: this.props.checkPermission('ravens.video_stream', 'view', { resourceId: raven.ravenUuid })
        }));
    }

    setPendingInvite = (invitationDetails) => {
        this.setState({
            pendingInvite: invitationDetails
        });

        CognitoUtil.setUserPendingInvite(invitationDetails);
    }

    getPendingInvite = () => {
        
        const searchParams = new URLSearchParams(window.location.search);
        const token = searchParams.get('token');

        if(!token) return;

        const pendingInvite = CognitoUtil.getUserPendingInvite(token);
        if(pendingInvite) {
            this.setState({
                pendingInvite: pendingInvite
            });
        }
    }

    loadSurveys = () => {
        const stage = this.state.user && this.state.user.stage;
        if (!stage) {
            console.warn("Cannot load surveys, stage is not available.");
            return;
        }

        const url = `https://s3.amazonaws.com/resources.raven.is/${stage}/surveys/active-surveys.json`;

        fetch(url)
            .then(response => {
                if (!response.ok) {
                    // File not found will result in a 404 or 403, which is not "ok"
                    throw new Error(`Failed to fetch surveys, status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (Array.isArray(data)) {
                    const surveys = data
                        .filter(s => s && s.hash) // must have a hash
                        .map(s => ({
                            path: s.path || '/',
                            mode: s.mode || 'click',
                            hash: s.hash
                        }));
                    this.setState({ surveys });
                } else {
                    console.warn("Survey data is not an array:", data);
                    this.setState({ surveys: [] });
                }
            })
            .catch(error => {
                console.error("Error loading surveys:", error.message);
                this.setState({ surveys: [] }); // On error (e.g. file not found), set to empty array
            });
    }

    shouldShowSurvey = (survey) => {
        if (!survey) return false;
        if (survey.mode === 'popup') return true;
        if (survey.mode === 'click' && this.state.showCurrentSurvey) return true;
        return false;
    }

    shouldShowFeedbackButton = () => {

        if(!this.state.user || !this.state.user.email) return false;

        if (!this.state.currentSurvey) return false;

        if(this.state.currentSurvey.mode !== 'click') return false;

        const key = lsUtil.USER_SURVEYS.replace('{user_email}', this.state.user.email.replace('@', '.'));

        const userSurveys = lsUtil.getObject(key) || {};

        // looks like user hasn't participated in any surveys
        if(!userSurveys) return true;

        // User hasn't responded to this survey
        if(!userSurveys[this.state.currentSurvey.hash]) return true;

        return false;
    }

    onFeedbackButtonClick = () => {
        this.setState({showCurrentSurvey: true});

        if(this.state.currentSurvey.mode !== 'click') return;

        const key = lsUtil.USER_SURVEYS.replace('{user_email}', this.state.user.email.replace('@', '.'));
        
        const userSurveys = lsUtil.getObject(key) || {};

        if(!userSurveys) return;

        userSurveys[this.state.currentSurvey.hash] = true;
        lsUtil.setObject(key, userSurveys);
    }

    applyChannelBranding = (channelCode, channelBrandingBaseUrl) => {
        // 1. Immediately apply non-asset branding (Globals, HTML class, Features)
        if (channelCode) {
            this.props.applyTheme(channelCode);
            updateGlobals(channelCode);
        }
        
        const channelBrandingFeatures = channelCode 
            ? BuildSettings.applyChannelBrandingFeatures({}, channelCode) 
            : BuildSettings.applyChannelBrandingFeatures({}, null);
            
        this.setState({ features: { ...this.state.features, ...channelBrandingFeatures, channel_branding_base_url: channelBrandingBaseUrl } });

        // 2. Handle assets (CSS)
        if (!channelBrandingBaseUrl) return; // Resetting was handled above
        
        const existing = document.getElementById(CHANNEL_STYLE_ID);
        if (existing && existing.href.includes(channelBrandingBaseUrl)) return;

        const link = document.createElement('link');
        link.id = CHANNEL_STYLE_ID;
        link.rel = 'stylesheet';
        link.href = `${channelBrandingBaseUrl}/styles/global.css`;
        
        if (existing) existing.remove();
        
        fetch(link.href, { method: 'GET' })
            .then(response => {
                const isCSS = response.headers.get('content-type') && response.headers.get('content-type').includes('text/css');
                if (response.ok && isCSS) {
                    document.head.appendChild(link);
                } else {
                    this.setState(prev => ({ 
                        features: { 
                            ...prev.features,
                            ...FALLBACK_CHANNEL_BRANDING_URLS // Imported from src/data/channels/index.js
                        } 
                    }));
                }
            })
            .catch(error => {
                console.warn(`Failed to fetch channel branding assets at ${link.href}`, error);
                this.setState(prev => ({ 
                    features: { 
                        ...prev.features,
                        ...FALLBACK_CHANNEL_BRANDING_URLS // Imported from src/data/channels/index.js
                    } 
                }));
            });
    }

    goToSnapshot = (ravenUuid) => {
        this.onSelectRaven(ravenUuid);
        this.setState({fromSnapshot: true});  // for setting the bottom panel when user clicks grid buttons to go to dashboard page
        
        HistoryUtil.push('/dashboard');
    };

    updateFromSnapshot = (setValue) => {
        this.setState({ fromSnapshot: setValue });
    }

    render() {

        // console.log('session', this.props, this.state);        
        const data = {
            accountDetails: this.state.accountDetails,
            updateRavens: this.updateRavens,
            getUserData: this.getUserData,
            getUsers: this.getUsers,
            deleteUser: this.deleteUser,
            onLogout: this.onLogout,
            sortEvents: this.sortEvents,
            goToSnapshot: this.goToSnapshot,
            onSelectRaven: this.onSelectRaven,
            onDashboardImageSuccess: this.onDashboardImageSuccess,
            loadDashboard: this.loadDashboard,
            enableDFast: this.enableDFast,
            onSelectEvent: this.onSelectEvent,
            parentProps: this.props,
            refreshAccountDetails: this.refreshAccountDetails,
            setVisible: this.setVisible,
            setAllVisible: this.setAllVisible,
            setRavensSearchFilterOption: this.setRavensSearchFilterOption,
            setGeofencesSearchFilterOption: this.setGeofencesSearchFilterOption,
            setAssetsSearchFilterOption: this.setAssetsSearchFilterOption,
            changeVehicleName: this.changeVehicleName,
            pokeMap: this.pokeMap,
            onLiveStream: this.onLiveStream,
            getUserAccounts: this.getUserAccounts,
            onAccountSelected: this.onAccountSelected,
            onShowcaseRavenChanged: this.onShowcaseRavenChanged,
            goToSelectAccountPage: this.goToSelectAccountPage,
            cancelSelectAccount: this.cancelSelectAccount,
            getCurrentVehicleStates: this.getCurrentVehicleStates,
        };

        if(this.state.mqttService) {
            this.state.mqttService.setShowcaseTargetRavenUuid(this.state.showcaseTargetRavenUuid);
        }

        const appNamePrefix = this.state.features && this.state.features.app_name_prefix ? this.state.features.app_name_prefix + " | " : "";

        // check for an event summary (printable) type page that doesn't include navigation
        // the URL currently doesn't include an obvious identifier, so the method below looks for a sort of "signature" in the structure which ends with an even id
        let routeIsForEventSummary = false;
        const pathNameSplit = this.props.location.pathname.toLowerCase().split("/stats/history/"); // http://localhost:3000/en/stats/history/54c095ccb8425332bc0f27183b4ba588/15845/2022-10-23T04:06:03.000ZEVENT_IDLING_STARTED
        if (pathNameSplit.length === 2) { // general structure matches event summary url
            if (pathNameSplit[1].indexOf("zevent") !== -1) { // looking for an essential component of an event id in the trailing param(s)
                routeIsForEventSummary = true;
            }
        }

        const showFeedbackButton = this.shouldShowFeedbackButton();
        const pageSlug = getPageSlugFromPathname(this.props.location.pathname);

        return (
            <div id="sessionManager">

                {this.props.location.pathname.indexOf('/trip/') > 0 ? // show legacy header for trip share
                    <Header {...this.props} {...this.state} {...data} />
                :
                    null
                }

                <div id="mainContent">

                    <Switch>

                        <Route exact path="/:lang/" render={
                            (props) => {
                                const existingUser = CognitoUtil.getUser();
                                const needsPasswordChange = CognitoUtil.newPasswordRequired();
                                const hasSelectedAccount = CognitoUtil.getUserAccountsDetails()?.account;
                                const currentLocale = getCurrentLocale();

                                if (existingUser && hasSelectedAccount && !needsPasswordChange) {
                                    return <Redirect to={`/${currentLocale}/dashboard`} />;
                                } 
                                
                                return (
                                    <MainModuleGroup 
                                        legacyRenderWithoutNavigationMode={true} 
                                        className={`${pageSlug}-page-main-module-group`}
                                        mainModuleGroup={
                                            <LoginPage {...this.props} {...this.state} onLogin={this.onLogin} {...props} />
                                        }
                                    />
                                )                            
                            }
                        } />

                        <Route exact path="/:lang/select-account" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.select_account;
                                if (!this.state.user) {
                                    this.getUserOrRedirectToLogin()
                                    return null; // getUserOrRedirectToLogin will result in a state change and a re-render
                                }
                                return (
                                    /* SelectAccount page is better not to show the left panel or the top-right userMenu */
                                    <SelectAccount {...this.props} {...this.state}  {...props} {...data} />
                                )
                            }
                        } />

                        <Route exact path="/:lang/deep-link/:accountId?/:ravenId?/:cardId?/:eventId?" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <DeepLink {...this.props} {...this.state}  {...props} {...data} />
                                )
                            }
                        } />

                        <Route exact path="/:lang/dashboard/:resourceType?/:resourceId?" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.dashboard;

                                if (this.state.ravens !== null && this.state.ravens.length === 0 && this.state.user && this.state.user.accountChannelCode === "PRIME") {
                                    const currentLocale = getCurrentLocale();
                                    return <Redirect to={`/${currentLocale}/prime/store`} />;
                                }

                                return (
                                    /* DashboardPage uses MainModuleGroup directly */
                                    <DashboardPage {...this.props} {...this.state} {...data} {...props} mqttService={this.state.mqttService} mapUpdateKey={this.state.mapUpdateKey} fromSnapshot = {this.state.fromSnapshot} updateFromSnapshot = {this.updateFromSnapshot}/>
                                )
                            }
                        } />
                        
                        <Route exact path="/:lang/snapshot/:resourceType?/:resourceId?" render={
                            (props) => {
                                if (!this.state.user || !this.state.user.gridViewUiEnabled) {
                                    const currentLocale = getCurrentLocale();
                                    return <Redirect to={`/${currentLocale}/dashboard`} />;
                                }
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.grid;
                                return (
                                    <GridPage {...this.props} {...this.state} {...data} {...props} mqttService={this.state.mqttService} selectedRaven={this.state.selectedRaven} ravens={this.state.ravens}/>
                                )
                            }
                        } />

                        <Route path="/:lang/stats/history/:ravenUuid/:cardId/:eventId" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.event_summary;
                                return (
                                    <EventSummaryPage {...this.props} {...this.state} {...props} {...data} mqttService={this.state.mqttService} />
                                )
                            }
                        } />

                        <Route path="/:lang/stats/history/:ravenUuid?/:cardId?" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.history;
                                return (
                                    /* History uses MainModuleGroup directly */
                                    <History {...this.props} {...this.state} {...props} {...data} mqttService={this.state.mqttService} />
                                )
                            }
                        } />

                        <Route path="/:lang/stats/reports/:parentGroupingType?" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.reports;
                                return (
                                    <MainModuleGroup mainModuleGroup={
                                        <ReportsPage {...this.props} {...this.state} {...data} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route path="/:lang/stats/review/:parentGroupingType?" render={
                            (props) => {
                                // setting document.title moved to Coaching component's parentGroupType switch statement
                                return (
                                    /* Coaching uses MainModuleGroup directly */
                                    <Coaching {...this.props} {...this.state} {...data} {...props} />
                                )
                            }
                        } />

                        <Route exact path="/:lang/account/:parentGroupingType?" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.account;
                                return (
                                    <MainModuleGroup mainModuleGroup={
                                        <AccountPage {...this.props} {...this.state} {...data} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/media" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup mainModuleGroup={
                                        <MediaPage {...this.props} {...this.state} {...data} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/forgot-password" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <ForgotPasswordPage {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/new-password" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <NewPasswordPage {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/reset-password" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <ResetPasswordPage {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/support/" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup mainModuleGroup={
                                        <SupportPage {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/create-account" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <CreateAccountPage {...this.props} {...this.state} {...props} setPendingInvite={this.setPendingInvite} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/verify-account" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <VerifyAccountPage {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route exact path="/:lang/finalize-invite" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <FinalizeInvitationPage {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />

                        <Route path="/:lang/trip/:tripUuid" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <TripSharingPage {...this.props} {...props} {...this.state} /> // no MainModuleGroup wrapper, legacy header and footer included for trip share as well
                                )
                            }
                        } />

                        <Route path="/:lang/settings" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + " - " + strings.settings;
                                return (
                                    <MainModuleGroup mainModuleGroup={
                                        <Settings {...this.props} {...this.state} {...props} {...data} ravenConfigDataSource={this.state.ravenConfigDataSource} />
                                    }/>
                                )
                            }
                        } />

                        <Route path="/:lang/invitation" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <InvitationPage {...this.props} {...this.state} {...props} setPendingInvite={this.setPendingInvite} />
                                    }/>
                                )
                            }
                        } />

                        <Route path="/:lang/prime/create-account" render={(props) => (
                            <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                <Suspense fallback={<div>Loading...</div>}>
                                    <CreateAccountFlow {...this.props} {...this.state} {...props} getUserData={this.getUserData} />
                                </Suspense>
                            }/>
                        )} />

                        <Route path="/:lang/prime/store" render={(props) => (
                            <MainModuleGroup mainModuleGroup={
                                <Suspense fallback={<div>Loading...</div>}>
                                    <PrimeStorePage showFeedbackButton={showFeedbackButton}{...this.props} {...this.state} {...props} getUserData={this.getUserData} />
                                </Suspense>
                            }/>
                        )} />

                        <Route path="/:lang/prime" render={(props) => (
                            <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                <Suspense fallback={<div>Loading...</div>}>
                                    <PrimePage {...this.props} {...this.state} {...props} getUserData={this.getUserData} />
                                </Suspense>
                            }/>
                        )} />

                        <Route path="/:lang/localization" render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix;
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <LocalizationIssues {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />

                        {/*<Route path="/:lang/license" render={(props) => (
                                <LicensePage />
                            )} />*/}

                        <Route render={
                            (props) => {
                                document.title = appNamePrefix + strings.app_name_suffix + "- 404";
                                return (
                                    <MainModuleGroup legacyRenderWithoutNavigationMode={true} mainModuleGroup={
                                        <NotFoundPage {...this.props} {...this.state} {...props} />
                                    }/>
                                )
                            }
                        } />
                    </Switch>
                    {this.props.location.pathname.indexOf('/trip/') === -1 && !routeIsForEventSummary ?
                        <>
                        <MainNavigation {...data} className={`${pageSlug}-page-main-navigation`} features={this.state.features} user={this.state.user} ravens={this.state.ravens} routerLocation={this.props.history ? this.props.history.location : undefined}  accountDetails={this.state.accountDetails} />
                        <UserMenu features={this.state.features} accounts={this.state.accounts} user={this.state.user} ravens={this.state.ravens} accountDetails={this.state.accountDetails} onLogout={data.onLogout} showFeedbackButton={showFeedbackButton} onFeedbackButtonClick={this.onFeedbackButtonClick} />
                        <BuildIdentificationBadge />
                        </>
                    :
                        null
                    }
                    {this.props.location.pathname.indexOf('/trip/') > 0 ? // show legacy footer for trip share
                        <Footer {...this.props} user={this.state.user} />
                    :
                        null
                    }
                </div>
                {this.state.liveStreamSettings &&
                    <Protected resource="ravens.video_stream" action="view" resourceId={this.state.liveStreamSettings.ravenUuid}>
                        <LiveStream
                            stage={this.state.user.stage}
                            ravenUuid={this.state.liveStreamSettings.ravenUuid}
                            vehicleName={this.state.liveStreamSettings.vehicleName}
                            defaultCamera={this.state.liveStreamSettings.defaultCamera}
                            startDate={this.state.liveStreamSettings.startDate}
                            onClose={this.onCloseLiveStream}
                        />
                    </Protected>
                }

                {this.shouldShowSurvey(this.state.currentSurvey) && (
                    <Survey survey={this.state.currentSurvey} />
                )}

                <PermissionsDebugger ravens={this.state.ravens} features={this.state.features} />
                <BackToTopButton />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {};
};

const mapDispatchToProps = dispatch => {
    return {
        dispatch,
        setUserGeneralPermissions: (currentAccount, accountDetails = {}) => {
            const { grantedPermissions = [] } = accountDetails;
            const { ravenCount = 0 } = currentAccount || {};
            const context = { account: accountDetails, ravenCount };
            return dispatch(Permissions.thunks.setGeneralPermissions(grantedPermissions, context));
        },
        setUserResourcePermissions: (resourceType, resourceKey, resourceList = []) => {
            const context = { resourceKey: resourceKey };
            return dispatch(Permissions.thunks.setResourcePermissions(resourceType, resourceList, context));
        },
        clearUserPermissions: () => dispatch(Permissions.thunks.clear()),
        checkPermission: (resource, action, context) => dispatch(Permissions.thunks.can(resource, action, context)),
        setMainModuleGroupNavigation: (isCollapsed) => dispatch(layoutTemplateModularFullscreenDispatchActions.setMainModuleGroupNavigation(isCollapsed)),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SessionManager);

